import {
  CheckCircle2,
  Clock,
  AlertCircle,
  XCircle,
  Loader2,
} from "lucide-react";
import { InvoiceState } from "@shared/types/InvoiceDto";
import { TestState } from "@shared/types/WorkOrderDto";
import { DeploymentState } from "@shared/types/WorkOrderDto";

export function formatDate(date: string): string {
  return new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
}

export function getStatusConfig(status: InvoiceState) {
  switch (status) {
    case "PAID":
      return {
        label: "Paid",
        icon: CheckCircle2,
        className: "bg-emerald-500/10 text-emerald-500 border-emerald-500/20",
      };
    case "PENDING":
      return {
        label: "Pending",
        icon: Clock,
        className: "bg-amber-500/10 text-amber-500 border-amber-500/20",
      };
    case "UNPAID":
      return {
        label: "Unpaid",
        icon: AlertCircle,
        className: "bg-red-500/10 text-red-500 border-red-500/20",
      };
  }
}

export function getTestStateConfig(state: TestState) {
  switch (state) {
    case "PASSED":
      return { icon: CheckCircle2, className: "text-emerald-500" };
    case "FAILED":
      return { icon: XCircle, className: "text-red-500" };
  }
}

export function getDeploymentStateConfig(state: DeploymentState) {
  switch (state) {
    case "PASSED":
      return {
        icon: CheckCircle2,
        className: "text-emerald-500",
        label: "Deployed",
      };
    case "FAILED":
      return { icon: XCircle, className: "text-red-500", label: "Failed" };
    case "BUILDING":
      return {
        icon: Loader2,
        className: "text-amber-500 animate-spin",
        label: "Building",
      };
  }
}
